import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SectionBox = styled(Box)(() => ({
  margin: '20px 160px 60px',
}));

export const SelectedText = styled(Typography)(() => ({
  fontSize: '28px',
  color: '#707070',
}));

export const FlexCenterBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  margin: '20px 0',
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  width: '450px',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
  [theme.breakpoints.down('lg')]: {
    maxWidth: '300px',
  },
}));
